export default {"src":"/_next/static/media/bc-logo.6fc04542.svg","height":34,"width":146,"blurWidth":0,"blurHeight":0};